import React from 'react';
import { useAppDispatch } from '@/hooks/redux';
import { showModal } from '@/store/slices/modalSlice';
import { emit } from '@/utils/emitter';
import VerificationCodeModal from '@/features/auth/components/Modals/VerificationCodeModal';
import { User } from '@/types/models/user';

const DownloadVerificationCodeModal = ({
  data,
  hideModal,
}: {
  data?: any;
  hideModal: () => void;
}) => {
  const dispatch = useAppDispatch();

  const handleClose = () => {
    data?.onCancel?.();
    hideModal();
  };

  const handleUsePassword = () => {
    dispatch(
      showModal({
        modalKey: 'DownloadLogin',
        modalData: {
          ...data,
          initialEmail: data?.email,
        },
      })
    );
  };

  const handleVerified = async (_user: User) => {
    hideModal();

    try {
      if (data?.onSuccess) {
        await data.onSuccess();
      } else {
        emit('download:step-completed', {
          extension: data?.extension,
          toolType: data?.toolType,
          originEntryPoint: data?.originEntryPoint,
        });
      }
    } catch (error) {
      console.error('Download after verification login failed:', error);
    }
  };

  return (
    <VerificationCodeModal
      email={data?.email ?? ''}
      initialResendDelay={data?.initialResendDelay}
      verificationMode={data?.verificationMode}
      onClose={handleClose}
      onUsePassword={handleUsePassword}
      onVerified={handleVerified}
    />
  );
};

export default DownloadVerificationCodeModal;
